import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/Landing.module.css';

type StorefrontLayoutProps = {
  children: React.ReactNode;
};

function Icon({ name }: { name: 'search' | 'bag' | 'user' }) {
  const paths = {
    search: <><circle cx="11" cy="11" r="6.5" /><path d="m16 16 4 4" /></>,
    bag: <><path d="M5 8h14l-1 12H6L5 8Z" /><path d="M9 8a3 3 0 0 1 6 0" /></>,
    user: <><circle cx="12" cy="8" r="3.5" /><path d="M5 20c.7-3.2 3.1-5 7-5s6.3 1.8 7 5" /></>,
  };

  return <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true">{paths[name]}</svg>;
}

export default function StorefrontLayout({ children }: StorefrontLayoutProps) {
  const navigate = useNavigate();

  return (
    <div className={styles.storefront}>
      <div className={styles.offerBar}>Free shipping on orders over Rs. 999 <span>Use code GLOW15 for 15% off your first order</span></div>
      <header className={styles.header}>
        <button className={styles.mobileMenu} aria-label="Open menu">&#9776;</button>
        <a className={styles.brand} href="/" aria-label="Luma home">luma<span>.</span></a>
        <nav className={styles.nav} aria-label="Main navigation">
          <a href="/#products">New in</a>
          <a href="/#categories">Makeup</a>
          <a href="/#categories">Skincare</a>
          <a href="/#categories">Hair</a>
          <a href="/#categories">Fragrance</a>
          <a href="/#products">Brands</a>
          <a className={styles.saleLink} href="/#products">Sale</a>
        </nav>
        <div className={styles.headerActions}>
          <button className={styles.searchButton} aria-label="Search"><Icon name="search" /><span>Search products</span></button>
          <button aria-label="Account" onClick={() => navigate('/login')}><Icon name="user" /></button>
          <button aria-label="Shopping bag"><Icon name="bag" /><b>0</b></button>
        </div>
      </header>

      {children}

      <footer className={styles.footer}>
        <div className={styles.footerBrand}>luma<span>.</span><p>Beauty, made personal.</p></div>
        <div><strong>Explore</strong><a href="/#categories">Categories</a><a href="/#products">Bestsellers</a><a href="/#journal">Luma journal</a></div>
        <div><strong>Need help?</strong><a href="mailto:hello@luma.example">Contact us</a><a href="/">Shipping &amp; returns</a><a href="/">FAQs</a></div>
        <div><strong>Stay in the know</strong><p>New drops and considered beauty, in your inbox.</p><div className={styles.emailForm}><input type="email" aria-label="Email address" placeholder="Your email address" /><button aria-label="Subscribe">-&gt;</button></div></div>
      </footer>
    </div>
  );
}